// src/lib/reviews.js
// Single source of truth for our public review figures + URLs, so the number
// shown on the site is accurate and changed in ONE place when it moves.
//
// These are the LIVE Google Business Profile figures. Update GOOGLE_RATING /
// GOOGLE_REVIEW_COUNT here whenever the profile changes (rare at this volume) —
// every badge and link across the site reads from here.
//
// IMPORTANT — two distinct Google URLs, do not mix them up:
//   • GOOGLE_REVIEWS_URL  → opens the profile straight on the reviews list, for
//     PROSPECTS reading proof. This is what the site's "Google reviews" cues link to.
//   • GOOGLE_WRITE_REVIEW_URL → opens the review-writing form, for CUSTOMERS we
//     ask for a review AFTER verification (post-verification follow-up email).
// Sending a prospect to the writereview form (the old testimonials-link bug) shoved
// people trying to READ proof into a form to WRITE it — never do that.

export const GOOGLE_PLACE_ID = 'ChIJe839nR-xe0gRmaa3KGUZzCs';

export const GOOGLE_REVIEWS_URL = `https://search.google.com/local/reviews?placeid=${GOOGLE_PLACE_ID}`;
export const GOOGLE_WRITE_REVIEW_URL = `https://search.google.com/local/writereview?placeid=${GOOGLE_PLACE_ID}`;

// Live Google Business Profile score. Keep in sync with the public profile.
export const GOOGLE_RATING = 4.3;
export const GOOGLE_REVIEW_COUNT = 6;

// Trustpilot profile. We link to it but deliberately do NOT display a numeric
// score anywhere (or assert one in schema) — a hardcoded rating drifts from the
// live profile, so the link is the source of truth for the current score.
export const TRUSTPILOT_REVIEWS_URL = 'https://uk.trustpilot.com/review/rjohnson.ltd';
